import React from 'react';
import { useTranslation } from 'react-i18next';

import giftIcon from '@shared/assets/lg_ag26/gift.png';

import styles from '../styles/StAg26StepsBanner.module.css';

const STEPS = [
  { n: 1, labelKey: 'st_ag26_step_enter' },
  { n: 2, labelKey: 'st_ag26_step_verify' },
  { n: 3, labelKey: 'st_ag26_step_enjoy' },
];

interface Props {
  showTrial?: boolean;
}

/**
 * Hero for the `st_ag26` (UAE Marketing DCB / "3 steps") v5 variation.
 * Replaces the default v5 Lottie and the `lg_ag26` Unlock VUZ banner.
 */
export const StAg26StepsBanner: React.FC<Props> = ({ showTrial = true }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('st_ag26_steps_title')}</h1>

      <div className={styles.stepper} aria-hidden>
        {STEPS.map((step, index) => (
          <React.Fragment key={step.n}>
            <div className={styles.step}>
              <div className={styles.chip}>{step.n}</div>
              <p className={styles.stepLabel}>{t(step.labelKey)}</p>
            </div>
            {index < STEPS.length - 1 ? <div className={styles.connector} /> : null}
          </React.Fragment>
        ))}
      </div>

      <p className={styles.tagline}>{t('st_ag26_tagline')}</p>

      {showTrial ? (
        <div className={styles.giftRow}>
          <img className={styles.giftIcon} src={giftIcon} alt="" aria-hidden />
          <div className={styles.trialInfo}>
            <div className={styles.freeBadge}>
              <span className={styles.freeBadgeText}>{t('lg_ag26_free_badge')}</span>
            </div>
            <p className={styles.priceLine}>{t('lg_ag26_price_line')}</p>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default StAg26StepsBanner;
